import { render, staticRenderFns } from "./DetailDown.vue?vue&type=template&id=ef4c637a"
import script from "./DetailDown.vue?vue&type=script&lang=js"
export * from "./DetailDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports